import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <>
      <Helmet>
        <title>Page not found — Cloakling</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <section className="mx-auto flex max-w-prose flex-col items-start gap-6 px-4 py-24">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-cloak-accent">
          404
        </p>
        <h1 className="text-3xl font-bold tracking-tight text-ink md:text-4xl">
          We can’t find that page.
        </h1>
        <p className="max-w-copy text-base leading-relaxed text-graphite md:text-lg">
          The link may be old, or we may have moved it. Head back to the home page and try again.
        </p>
        <Link
          to="/"
          className="inline-flex items-center rounded-button bg-cloak-accent px-5 py-3 font-semibold text-page no-underline transition-colors hover:bg-cloak-accent/90"
        >
          Back to home
        </Link>
      </section>
    </>
  );
}
